"use client";

import { useMemo } from "react";
import { useTourParamCleanup } from "./useTourParamCleanup";
import { ALL_TOURS } from "./catalogue";

export function TourParamCleanupMount() {
  const claimedIds = useMemo(() => new Set<string>(ALL_TOURS.map((t) => t.id)), []);
  useTourParamCleanup(claimedIds);
  return null;
}
